function SmartLock() {
    var self = this;
    var providers = {
        fb: 'https://www.facebook.com',
        gm: 'https://accounts.google.com'
    }
    this.savePassword = function (email, password, name, iconUrl) {
        if (navigator.credentials && email && existCredential('PasswordCredential')) {
            this.signOut();

            var cred = new PasswordCredential({
                id: email,
                password: password,
                name: name,
                iconURL: iconUrl
            });
            navigator.credentials.store(cred);
        }
    };

    this.saveGmail = function (id, name, iconUrl) {
        if (navigator.credentials && id && existCredential('FederatedCredential')) {
            this.signOut();
            var c = new FederatedCredential({
                id: id,
                name: name,
                provider: 'https://accounts.google.com',
                iconURL: iconUrl
            });
            navigator.credentials.store(c);
            return c;
        }
        return null;
    }
    this.saveFacebook = function (id, name, iconUrl) {
        if (navigator.credentials && id && existCredential('FederatedCredential')) {
            this.signOut();

            var cred = new FederatedCredential({
                id: id,
                name: name,
                provider: providers.fb,
                iconURL: iconUrl
            });
            navigator.credentials.store(cred);
            return cred;

        }
    }


    this.get = function (cb, password, optional) {
        if (navigator.credentials) {
            optional = optional || false;
            password = password || false;
            navigator.credentials.get({
                password: password,
                //unmediated: false,
                mediation: 'optional',
                federated: {
                    providers: [providers.gm,
                                providers.fb]
                }

            }).then(function (cred) {
                processGet(cb, cred);
            });
        }
    }

    var processGet = function (cb, cred) {
        var response = {
            credential: cred,
            type: null
        };
        if (cred) {
            switch (cred.type) {
                case 'password':
                    response.type = 'nativo';
                    break;
                case 'federated':
                    if (cred.provider == providers.fb) response.type = 'fb';
                    else if (cred.provider == providers.gm) response.type = 'gm';
                    break;
            }
        }
        cb && cb(response);
    }

    this.signOut = function () {
        if (navigator.credentials) {
            navigator.credentials.preventSilentAccess();
        }
    }

    var existCredential = function (credential) {
        return typeof window[credential] == 'function';
    }
}

window.smartlock = new SmartLock();


// WEBPACK FOOTER //
// ./Statics/scripts/common/smartlock.js